<template>
  <div >
    <section

      class="coupon_phone"
    >
      <section class="coupon_con">
          <h4>请选择输入手机号方式</h4>
          <TabMethod v-on:listenChooseEvent="chooseWhichTab" :items="items" :defaultActiveIndex="tabIndex"/>
          <AddPhone class="phone_con" v-if="tabIndex == 1" v-on:listenPhoneChange="getPhones"/>
          <BatchUpdate v-else-if="tabIndex == 2" v-on:listenkeyChange="getKey"/>
      </section>
      <section
        v-if ="couponDataList.length>0"
        class=""
      >
        <h4>请选择要发的券</h4>
        <ul
          class="unitComWrap"
          v-loading= "unitComLoading"
        >
          <coupon-unit
              v-for="couponObj in couponDataList"
              v-bind:key="couponObj.id"
              v-bind="couponObj"
              v-on:listenCouponUnitChange="updateCouponMap"
          ></coupon-unit>
        </ul>
      </section>
      <!-- <p
        v-else-if='getUsableOrdersByGroupIdSuccess'
        class="noCoupon"
      >
        暂无可发出行券，
        <router-link class="link" to="/purchasecoupon/purchase">购券</router-link>
      </p> -->
      <div
        class="noCouponWrap"
        v-else-if='getUsableOrdersByGroupIdSuccess'
      >
        <h4>暂无可发出行券</h4>
        <p
          v-if='haveCheckingOrders'
        >您的订单正在审核中，预计1个工作日内审核完成，请耐心等待，如需帮助，可拨打<br/>24小时客服热线400-000-0777，我们会尽快与您取得联系</p>
        <el-button @click="btnClick('/purchasecoupon/purchase')">购券</el-button>
      </div>
    </section>

    <div class="btnWrap" v-if ="couponDataList.length>0">
      <el-button type="primary" @click = 'sendCoupon'>确认发券</el-button>
    </div>
    <el-dialog
        :visible.sync="dialogSendCoupon"
        width ="400px"
        custom-class = "sendCouponAskDialog"
        :show-close = "false"
        center
    >
        <div class="askContent">
          <h6 v-if="tabIndex == 1">确定要给以下手机发券吗？</h6>
          <h6 v-else-if="tabIndex == 2">确定要给{{baseNum}}人发券吗？</h6>
          <ul v-if="tabIndex == 1" class="item_con">
            <li class="item" v-for="(item) in spacePhones" :key="item" >
              {{item}}
            </li>
          </ul>
          <p>每人发券张数如下：</p>
          <span
            v-for="(str,index) in couponStr"
            :key="index"
          >{{str}}</span>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="hiddenSendCouponDialog">取 消</el-button>
            <el-button type="primary" @click="doSend" :loading="SendCouponBtnLoading">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import TabMethod from './components/tabMethod.vue'
import AddPhone from './components/addPhone.vue'
import BatchUpdate from './components/batchUpdate.vue'
import CouponUnit from './components/couponUnit.vue'
import {mapState} from 'vuex'
import { Message } from 'element-ui'
export default {
  beforeMount: function () {
    if (this.$store.state.header.selfGroup && Object.keys(this.$store.state.header.selfGroup).length > 0) {
      this.$store.dispatch('sendCoupon/getUsableOrdersByGroupId', {
        groupId: this.$store.state.header.selfGroup.groupId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
    }
  },
  beforeDestroy: function () {
    this.$store.commit('sendCoupon/initState')
  },
  mounted: function () {
    this.omgTrack('es_chuxingquan_xieyi_share_manage_sw', '出行券模块进入发券管理页面')
  },
  data () {
    return {
      items: [{main: '手动输入', sub: '(最多添加5个手机号)'}, {main: '批量上传手机号', sub: '(xlsx文件，最多添加1000个手机号)'}],
      tabIndex: 1,
      phones: [],
      spacePhones: [],
      pageNum: 1,
      pageSize: 3,
      dialogSendCoupon: false,
      SendCouponBtnLoading: false,
      couponsMap: {},
      sendCouponVOs: [],
      couponStr: [],
      key: '',
      phonesNum: 0
    }
  },
  computed: {
    ...mapState('sendCoupon', [
      'couponDataList',
      'sendCouponSuccess',
      'getUsableOrdersByGroupIdSuccess',
      'haveCheckingOrders'
    ]),
    baseNum: function () {
      return this.tabIndex === 1 ? this.phones.length : this.phonesNum
    },
    couponDataListFilter: function () {
      return this.couponDataList.filter(function (couponObj) {
        return couponObj.availableNumber > 0
      })
    },
    unitComLoading: function () {
      return !this.getUsableOrdersByGroupIdSuccess
    }
  },
  methods: {
    chooseWhichTab: function (key) {
      this.tabIndex = key
    },
    getPhones: function (phones, spacePhones) {
      this.phones = phones
      this.spacePhones = spacePhones
    },
    getKey: function (data) {
      this.key = data.key
      this.phonesNum = data.number
    },
    sendCoupon: function () {
      console.log(this.couponsMap)
      let isRightData = true
      let resetDateList = this.couponDataList.map((item, index) => {
        item.warning = false
        item.warningTxt = ''
        return item
      })
      this.$store.commit('sendCoupon/updateCouponDataListFormCompon', {
        dataList: resetDateList
      })
      if (this.baseNum === 0) {
        return Message.error('您还未添加手机号码')
      }
      if (Object.keys(this.couponsMap).length === 0) {
        return Message.error('请选择要发的券')
      }
      // 券数量验证
      let dataList = this.couponDataList.map((item, index) => {
        if (this.couponsMap[item.id]) {
          // 已选数量
          let sendNumber = this.couponsMap[item.id].sendNumber
          if ((this.baseNum * sendNumber) > item.availableNumber) {
            item.warning = true
            item.warningTxt = '已经超过可发张数'
            isRightData = false
          }
        }
        return item
      })
      if (!isRightData) {
        this.$store.commit('sendCoupon/updateCouponDataListFormCompon', {
          dataList
        })
        return Message.error('券数量有误，请检查券数量')
      }
      // 验证通过
      this.sendCouponVOs = []
      let couponStrArr = []
      Object.keys(this.couponsMap).forEach((key) => {
        if (this.couponsMap[key].sendNumber > 0) {
          this.sendCouponVOs.push({
            id: key,
            sendNumber: this.couponsMap[key].sendNumber
          })
          couponStrArr.push(`【${this.couponsMap[key].couponAmount}元${this.couponsMap[key].productName}券】X ${this.couponsMap[key].sendNumber}`)
        }
      })
      console.log(this.sendCouponVOs)
      this.couponStr = couponStrArr
      this.dialogSendCoupon = true
    },
    hiddenSendCouponDialog: function () {
      this.dialogSendCoupon = false
    },
    doSend: function () {
      this.SendCouponBtnLoading = true
      const {groupId} = this.$store.state.header.selfGroup
      let sendCouponParams = {
        sendCouponVOs: this.sendCouponVOs,
        directionType: (this.tabIndex === 1 ? 4 : 5),
        groupId
      }
      if (this.tabIndex === 1) {
        sendCouponParams.phones = this.phones.join(',')
      } else {
        sendCouponParams.key = this.key
      }
      this.$store.dispatch('sendCoupon/sendCoupon', sendCouponParams)
    },
    updateCouponMap: function (id, sendNumber, couponAmount, productName) {
      console.log(id, sendNumber, couponAmount, productName)
      // reset item
      let resetItemData = this.couponDataList.map((item, index) => {
        if (id === item.id) {
          item.warning = false
          item.warningTxt = ''
        }
        return item
      })
      this.$store.commit('sendCoupon/updateCouponDataListFormCompon', {
        dataList: resetItemData
      })
      if (sendNumber === 0) {
        this.$delete(this.couponsMap, id)
      } else {
        this.couponsMap[id] = {sendNumber, couponAmount, productName}
      }
    },
    btnClick: function (url) {
      this.$router.push(url).catch(err => {})
    }
  },
  watch: {
    dialogSendCoupon (val) {
      if (!val) {
        this.SendCouponBtnLoading = false
      }
    },
    tabIndex (val) {
      if (val === 1) {
        this.phones = []
      } else {
        this.key = ''
        this.phonesNum = 0
      }
    },
    sendCouponSuccess (val) {
      if (val) {
        this.dialogSendCoupon = false
        this.$store.commit('sendCoupon/sendCouponSuccess', {res: false})
        if (val.data.status === 0) {
          Message({
            message: '发券成功',
            type: 'success',
            duration: '1000',
            onClose: function () {
              window.location.reload()
            }
          })
        } else {
          let errorId = val.data.id
          let errorMsg = val.data.status === 1 ? '券数量不足' : '已过期'
          let dataList = this.couponDataList.map((item) => {
            if (item.id === errorId) {
              item.warning = true
              item.warningTxt = errorMsg
              if (val.data.status === 1) {
                item.availableNumber = val.data.number
              }
            } else {
              item.warning = false
              item.warningTxt = ''
            }
            return item
          })
          this.$store.commit('sendCoupon/updateCouponDataListFormCompon', {
            dataList
          })
          Message.error(errorMsg)
        }
      }
    },
    getUsableOrdersByGroupIdSuccess (val) {
      console.log(1111, val)
      if (val && this.couponDataList.length === 0) {
        this.$store.dispatch('sendCoupon/ifHaveCheckingOrders', {
          groupId: this.$store.state.header.selfGroup.groupId
        })
      }
    }
  },
  components: {
    TabMethod,
    AddPhone,
    BatchUpdate,
    CouponUnit
  }
}
</script>

<style scoped lang="stylus">
.coupon_phone
  margin-left: 40px

  padding-bottom 100px
h4
  font-family: PingFangSC-Medium, sans-serif
  font-size: 14px
  color: #333
  text-align: left
  margin: 30px 0 20px
.coupon_con
  margin-top: 10px
  width: 544px
.phone_con
  background: #F3F4F5
.unitComWrap
  min-width  800px
  max-width 1100px
  display flex
  justify-content flex-start
  flex-wrap wrap
  background #F8F8F9
  padding-left 20px
  padding-top 20px
  max-height 730px
  overflow auto
  >li
    width 355px
.btnWrap
  padding-top: 16px;
  background-color: #fff;
  z-index: 100;
  padding-left: 40px;
  box-shadow: 0 -5px 15px 0 hsla(0,1%,65%,.15);
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 64px;
.sendCouponAskDialog
  .askContent
    text-align center
    font-size: 14px;
    color: #666666;
    line-height 20px
    .item_con
      font-size: 14px;
      color: #666;
    .item
      line-height: 24px;
      height: 24px;
    h6
      margin 0;
      margin-bottom 10px
      font-size: 20px;
      color: #333333;
    p
      font-size: 14px;
      color: #333333;
      font-weight bold
      margin-bottom 5px
    span
      display block
      line-height 24px
      height 24px
      font-size: 14px;
      color: #666666;
.noCouponWrap
  width 560px
  margin 160px auto 0
  text-align center
  h4
    font-size 20px
    font-weight 500
    text-align center
    margin 0 0 20px 0
    background-image url('../../images/billnodata.png')
    background-position top center
    background-size 120px
    padding-top 150px
    background-repeat no-repeat
  p
    color  #777
    font-size 14px
    margin-bottom 20px
  a
    text-decoration none
    color #3468ff

</style>
